module.exports = __webpack_public_path__ + "img/slideshare.e02a6216.png";